
    import './styles.scoped.css';
    export default {
  "body-cell": "awsui_body-cell_c6tup_1v8wb_93",
  "body-cell-wrap": "awsui_body-cell-wrap_c6tup_1v8wb_104",
  "is-visual-refresh": "awsui_is-visual-refresh_c6tup_1v8wb_116",
  "has-striped-rows": "awsui_has-striped-rows_c6tup_1v8wb_128",
  "body-cell-edit-active": "awsui_body-cell-edit-active_c6tup_1v8wb_131",
  "body-cell-editable": "awsui_body-cell-editable_c6tup_1v8wb_131",
  "has-striped-rows-sticky-cell-pad-left": "awsui_has-striped-rows-sticky-cell-pad-left_c6tup_1v8wb_137",
  "has-selection": "awsui_has-selection_c6tup_1v8wb_140",
  "body-cell-first-row": "awsui_body-cell-first-row_c6tup_1v8wb_146",
  "body-cell-last-row": "awsui_body-cell-last-row_c6tup_1v8wb_149",
  "body-cell-selected": "awsui_body-cell-selected_c6tup_1v8wb_149",
  "has-footer": "awsui_has-footer_c6tup_1v8wb_149",
  "body-cell-shaded": "awsui_body-cell-shaded_c6tup_1v8wb_159",
  "sticky-cell": "awsui_sticky-cell_c6tup_1v8wb_179",
  "sticky-cell-pad-left": "awsui_sticky-cell-pad-left_c6tup_1v8wb_187",
  "sticky-cell-last-right": "awsui_sticky-cell-last-right_c6tup_1v8wb_204",
  "sticky-cell-last-left": "awsui_sticky-cell-last-left_c6tup_1v8wb_208",
  "body-cell-next-selected": "awsui_body-cell-next-selected_c6tup_1v8wb_231",
  "body-cell-prev-selected": "awsui_body-cell-prev-selected_c6tup_1v8wb_235",
  "body-cell-editor": "awsui_body-cell-editor_c6tup_1v8wb_259",
  "body-cell-success": "awsui_body-cell-success_c6tup_1v8wb_264",
  "body-cell-success-form": "awsui_body-cell-success-form_c6tup_1v8wb_289",
  "body-cell-editor-form": "awsui_body-cell-editor-form_c6tup_1v8wb_289",
  "body-cell-success-row": "awsui_body-cell-success-row_c6tup_1v8wb_298",
  "body-cell-editor-row": "awsui_body-cell-editor-row_c6tup_1v8wb_298",
  "body-cell-success-controls": "awsui_body-cell-success-controls_c6tup_1v8wb_308",
  "body-cell-editor-controls": "awsui_body-cell-editor-controls_c6tup_1v8wb_308",
  "body-cell-disabled-edit": "awsui_body-cell-disabled-edit_c6tup_1v8wb_311",
  "body-cell-edit-disabled-popover": "awsui_body-cell-edit-disabled-popover_c6tup_1v8wb_348",
  "body-cell-has-success": "awsui_body-cell-has-success_c6tup_1v8wb_352"
};
  